import { Loading } from '@components'
import { FEATURE } from '@constants'
import { AdminDashboardDetailContainer } from '@containers'
import { hasFeature } from '@helpers/dashboard'
import { useGetFeatures } from '@hooks'
import { Navigate, useParams } from 'react-router-dom'

const AdminDashboardDetailPage = () => {
  const { dashboardId } = useParams()
  const { isLoading, data: featureList } = useGetFeatures()
  const isEnabled = hasFeature(featureList, FEATURE.ADMIN_DASHBOARD)

  if (isLoading) {
    return <Loading />
  }

  return isEnabled ? <AdminDashboardDetailContainer dashboardId={dashboardId} /> : <Navigate to='/' />
}

export default AdminDashboardDetailPage
